<template>
    <div id="wrapper" class="page">

        <div id="content-wrapper">
            <div class="container-fluid" style="overflow:auto; min-height: 700px;">
                <!-- <b-link href="#" @click.prevent="openModal">
            <i class="fas fa-plus mr-2"></i> Thêm
          </b-link>-->
                <div class="row" style="margin-left:1px;">
                    <button v-if="bonus_sf_add" class="btn btn-info mb-2 mr-2" @click.prevent="openModal">
                        <i class="fas fa-plus"></i> Add
                    </button>
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" size="sm"
                        class="my-0 mt-1">
                    </b-pagination>
                    <p style="margin-top: 8px; margin-left: 3px; color: #027bff;">Total: {{ totalRows }}</p>
                    <div style="flex-grow: 1" class="text-center"></div>
                    <button v-if="bonus_sf_paid" class="btn btn-warning mb-2 mr-3" @click.prevent="openModalPayment">
                        <i class="fas fa-money-check pr-1"></i> Payment
                    </button>
                    <button v-if="bonus_sf_report" class="btn btn-success mb-2 mr-3" @click.prevent="openModalReport">
                        <i class="fas fa-file-excel pr-1"></i> Report
                    </button>

                </div>
                <div class="row" style="margin-left:1px; height: 45px;">
                    <b-form-input class="mr-2 " style="flex-grow: 1; width:1px;" v-model="search"
                        placeholder="Search by Code, Project Name, EP" @keydown.enter.prevent="queryItem" size="md" />
                    <p class="mt-2 mr-2">Status: </p>
                    <b-form-group class="mb-2 mr-2">
                        <b-form-select v-model="searchBonus.status" @change="queryItem">

                            <b-form-select-option value="Acct_Created">Acct_Created</b-form-select-option>
                            <b-form-select-option value="EP-In Progress">EP-In Progress</b-form-select-option>

                            <b-form-select-option value="EP-Pending Approval">Pending Approval</b-form-select-option>
                            <b-form-select-option value="EP-Rejected">Rejected</b-form-select-option>
                            <b-form-select-option value="EP-Approved">Approved</b-form-select-option>
                            <b-form-select-option value="EP-Lock">Locked</b-form-select-option>
                            <!-- <b-form-select-option value="EP-Lock-Out">Locked Out</b-form-select-option> -->
                            <b-form-select-option value="Paid 70">Paid 70</b-form-select-option>
                            <b-form-select-option value="Finish">Finish</b-form-select-option>
                            <b-form-select-option :value="null">All</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                    <button class="btn btn-secondary mb-2 mr-3 ml-2 " style="float:right; height: 37px; width: 93px;"
                        @click.prevent="queryItem">
                        <b-row> <i class="fas fa-search mt-1 mr-2 ml-3"> </i>
                            <p>Search</p>
                        </b-row>


                    </button>
                </div>
                <div class="row" style="margin-left:1px; height: 45px;">

                    <p class="mt-2 mr-2">Production House: </p>
                    <b-form-group class="mb-2 mr-2">
                        <b-form-select v-model="searchBonus.productionHouse" :options="optionsCompany"
                            @change="queryItem">
                            <b-form-select-option :value="null">All</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                    <p class="mt-2 mr-2">Approve by: </p>
                    <b-form-group class="mb-2 mr-2">
                        <b-form-select v-model="searchBonus.approveBy" :options="searchBonus.optionApprove"
                            @change="queryItem">
                            <b-form-select-option :value="null">All</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                    <p class="mt-2 mr-2">Date: </p>
                    <b-form-group class="mb-2 mr-2">
                        <b-form-select v-model="searchBonus.typeDate" @change="queryItem">
                            <b-form-select-option value="Liquidation">Liquidation</b-form-select-option>
                            <b-form-select-option value="Master">Master</b-form-select-option>
                            <b-form-select-option value="Shooting">Shooting</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                    <p class="mt-2 mr-2">Option: </p>
                    <b-form-group class="mb-2 mr-2">
                        <b-form-select v-model="searchBonus.filterDate" :options="optionsKyBaoCao_Report3"
                            @change="changeDateFilter">
                            <b-form-select-option :value="null">Customize</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                    <p class="ml-2 mt-2 mr-2">From</p>
                    <b-form-group class=" mr-2">
                        <vue-datepicker-local style="width: 130px" v-model="searchBonus.from" :local="local" clearable
                            @confirm="changeDate" show-buttons format="DD/MM/YYYY" />
                        <!-- <my-date-picker v-model="searchBonus.from" placeholder="DD/MM/YYYY"></my-date-picker> -->
                    </b-form-group>
                    <p class="mt-2 mr-2">To</p>
                    <b-form-group class="mr-2">
                        <vue-datepicker-local style="width: 130px" v-model="searchBonus.to" :local="local" clearable
                            @confirm="changeDate" show-buttons format="DD/MM/YYYY" />
                        <!-- <my-date-picker v-model="searchBonus.to" placeholder="DD/MM/YYYY"></my-date-picker> -->
                    </b-form-group>
                </div>
                <b-table :current-page="currentPage" :per-page="perPage" @filtered="onFiltered" bordered
                    head-variant="dark" hover responsive striped small table-variant="light" :fields="fields"
                    :items="items">


                    <template #cell(ep)="data">
                        <div>
                            <p> {{ convertName(data.item.ep) }}</p>

                        </div>

                    </template>

                    <template v-slot:cell(epRevenue)="data">
                        <span v-if="data.item.epRevenue > 0">
                            {{ data.item.epRevenue | numeral('0,0') }}
                        </span>
                        <span v-else> - </span>

                    </template>

                    <template v-slot:cell(epGross)="data">
                        <span v-if="!bonus_sf_view_all && data.item.epGross > 0">
                            {{ data.item.gross2.grossFrom + "% to " + data.item.gross2.grossTo + "%" }}
                        </span>
                        <span v-else-if="data.item.epGross > 0 && bonus_sf_view_all">
                            {{ data.item.epGross }}
                        </span>
                        <span v-else> - </span>
                    </template>

                    <template v-slot:cell(epBonus)="data">
                        <span v-if="data.item.epBonus > 0">
                            {{ data.item.epBonus | numeral('0,0') }}
                        </span>
                        <span v-else> - </span>

                    </template>

                    <template v-slot:cell(epPaid)="data">
                        <span v-if="data.item.epPaid > 0">
                            {{ data.item.epPaid | numeral('0,0') }}
                        </span>
                        <span v-else> - </span>

                    </template>

                    <template #cell(epStatus)="data">
                        <span v-if="data.item.epStatus == 'EP-Lock-Out'">
                            <b-badge style="background-color: #008DDA; color:white;">Locked Out</b-badge>
                        </span>
                        <span v-else-if="data.item.epStatus == 'EP-Lock'">
                            <b-badge style="background-color: #008DDA; color:white;">Locked</b-badge>
                        </span>
                        <span v-else-if="data.item.epStatus == 'EP-In Progress'">
                            <b-badge style="background-color: #fde897; color:black;">{{ data.item.epStatus }}</b-badge>
                        </span>
                        <span v-else-if="data.item.epStatus == 'EP-Pending Approval'">
                            <b-badge style="background-color: #ffc9d5; color:#5e1d23;">Pending Approval</b-badge>
                        </span>
                        <span v-else-if="data.item.epStatus == 'EP-Rejected'">
                            <b-badge style="background-color: #808080; color:white;">Rejected</b-badge>
                        </span>
                        <span v-else-if="data.item.epStatus == 'EP-Approved'">
                            <b-badge style="background-color: #c5e0b3; color:#092101;">Approved</b-badge>
                        </span>
                        <span v-else-if="data.item.epStatus == 'Acct_Created'">
                            <b-badge style="background-color: #f7cea0; color:#4c4976;">Acct_Created</b-badge>
                        </span>
                        <span v-else-if="data.item.epStatus == 'Paid 70'">
                            <b-badge style="background-color: #FF5F00; color:#FEFFD2;">Paid 70</b-badge>
                        </span>
                        <span v-else-if="data.item.epStatus == 'Finish'">
                            <b-badge style="background-color: #006769; color:white;">Finish</b-badge>
                        </span>
                        <span v-else> {{ data.item.epStatus }}</span>
                    </template>

                    <template v-slot:cell(epkpi)="data">
                        <span v-if="data.item.epkpi > 0">
                            {{ data.item.epkpi | numeral('0,0') }}
                        </span>
                        <span v-else> - </span>

                    </template>
                    <template #cell(epApprover)="data">
                        <div class="text-left">
                            <p> {{ data.item.epApproverEng }}</p>

                        </div>

                    </template>

                    <template #cell(dayOfMasterDelivery)="data">
                        {{ convertDate(data.item.dayOfMasterDelivery) }}
                    </template>
                    <template #cell(dateLiquidation)="data">
                        {{ convertDate(data.item.dateLiquidation) }}
                    </template>
                    <template #cell(lastDay)="data">
                        {{ convertDate(data.item.lastDay) }}
                    </template>
                    <template #cell(datePaid70)="data">
                        {{ convertToMMYYYY2(data.item.datePaid70) }}
                    </template>
                    <template #cell(datePaid100)="data">
                        {{ convertToMMYYYY2(data.item.datePaid100) }}
                    </template>


                    <template v-slot:cell(action)="data">
                        <b-link
                            v-if="bonus_sf_lock && ['EP-Lock', 'EP-Approved'].includes(data.item.epStatus) && bonus_sf_lock"
                            class=" mr-2" href="#" @click.prevent="lockProject(data)">
                            <span v-if="data.item.epLock == true || data.item.epLock == 'true'">
                                <i class="fas fa-lock text-warning"></i>
                            </span>
                            <span v-else>

                                <i class="fas fa-unlock text-primary"></i>
                            </span>
                        </b-link>
                        <!-- <b-link
                            v-if="bonus_sf_lock && ['EP-Lock', 'EP-Paid'].includes(data.item.epStatus) && bonus_sf_paid"
                            class=" mr-2" href="#" @click.prevent="PaidProject(data)">
                            <span v-if="data.item.epLockPaid == true || data.item.epLockPaid == 'true'">
                                <i class="fab fa-creative-commons-nc"></i>
                            </span>
                            <span v-else>

                                <i class="fas fa-money-bill-wave"></i>
                            </span>
                        </b-link> -->
                        <b-link class="text-success mr-2"
                            v-if="['EP-Pending Approval', 'EP-Approved'].includes(data.item.epStatus) && data.item.epApprover == $store.state.auth.accountId && bonus_sf_approve"
                            href="#" @click.prevent="approveRequest(data)">
                            <i class="fas fa-check-circle"></i>
                        </b-link>
                        <b-link v-if="data.item.epStatus == 'EP-In Progress'" class="text-secondary mr-2" href="#"
                            @click.prevent="SendRequest(data)">
                            <i class="fa fa-paper-plane"></i>
                        </b-link>
                        <b-link v-if="bonus_sf_edit" class="text-primary mr-2" href="#"
                            @click.prevent="openUpdateModal(data)">
                            <i class="fas fa-pencil-alt"></i>
                        </b-link>
                        <b-link v-if="bonus_sf_delete" class="text-danger" href="#" @click.prevent="deleteItem(data)">
                            <i class="fas fa-trash"></i>
                        </b-link>
                        <!-- <button class="btn btn-info mr-1" @click="openUpdateModal(data)" v-if="meeting_udpate">
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button class="btn btn-danger" @click="deleteItem(data)" v-if="meeting_delete">
                <i class="fas fa-trash-alt"></i>
              </button>             -->
                    </template>

                </b-table>
            </div>
        </div>
        <b-modal v-model="modalShow" size="lg" header-bg-variant="info" header-text-variant="light">

            <template v-slot:modal-title>
                <div v-if="item.id <= 0">Add </div>
                <div v-else>Update </div>
            </template>

            <template v-slot:modal-footer="{ ok, cancel }">
                <div class="w-100">
                    <b-button v-if="item.id > 0" class="float-left" variant="primary" @click="PrintDetail()"><i
                            class="fas fa-print mr-2 "></i>Print</b-button>
                    <b-button class="float-right mr-2" variant="info" @click="storeItem()"><i
                            class="fas fa-save mr-2"></i>Save</b-button>
                    <b-button class="float-right mr-2" variant="secondary" @click="cancel()"><i
                            class="fas fa-times mr-2"></i>Close</b-button>
                </div>
            </template>
            <b-container>
                <b-row>
                    <div
                        style="background-color: #5384d1; width: 100%; text-align: center; margin-left: 10px;margin-right: 10px; color: white;">
                        <b>Project Information</b>
                    </div>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>

                            <template v-slot:label>
                                Project Code
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-input v-model="item.code" required></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>

                            <template v-slot:label>Production House Name <code>*</code> </template>
                            <b-row>
                                <b-col>
                                    <b-form-select v-model="item.productionHouse" class=" pt-0 pb-0" size="md"
                                        :options="optionsCompany" value-field="madonvi" text-field="madonvi"
                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                        oninput="setCustomValidity('')" required>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>

                            <template v-slot:label>
                                Client Name
                                <span class="text-danger">*</span>
                            </template>
                            <multiselect v-model="item.client" placeholder selectedLabel="are selecting" track-by="ten"
                                label="ten" select-label="Enter to select" deselectLabel="Enter to remove"
                                :searchable="true" :options="optioncustomer">
                            </multiselect>
                            <!-- <b-form-input v-model="item.client" required></b-form-input> -->
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>

                            <template v-slot:label>
                                Project Name
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-input v-model="item.projectName" required></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>

                            <template v-slot:label>EP Name (Sales-driven EP only) <code>*</code> </template>
                            <b-row>
                                <b-col>
                                    <multiselect v-model="item.EP" track-by="name" label="name" placeholder
                                        selectedLabel="are selecting" select-label="Enter to select"
                                        deselectLabel="Enter to remove" :searchable="true" :options="optionEP"
                                        @select="unlockHopitalCity" @remove="lockHopitalCity">
                                    </multiselect>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group>

                            <template v-slot:label>Head of Production / PM Name <code>*</code> </template>
                            <b-row>
                                <b-col>
                                    <multiselect v-model="item.PM" placeholder selectedLabel="are selecting"
                                        track-by="name" label="name" select-label="Enter to select"
                                        deselectLabel="Enter to remove" :searchable="true" :options="optionPM">
                                    </multiselect>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <div v-if="item.id > 0"
                        style="background-color: #5384d1; width: 100%; text-align: center; margin-left: 10px;margin-right: 10px; color: white;">
                        <b>Financials</b>
                    </div>
                </b-row>
                <b-row v-if="item.id > 0">
                    <b-col>
                        <b-form-group>

                            <template v-slot:label>Day of liquidation </template>
                            <b-row>
                                <b-col>
                                    <vue-datepicker-local style="width: 100%" v-model="item.dateLiquidation"
                                        :local="local" clearable format="DD-MM-YYYY" />
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="item.id > 0">
                    <b-col>
                        <b-form-group>

                            <template v-slot:label>Revenue excluding VAT (VND) </template>
                            <b-row>
                                <b-col>
                                    <my-currency-input v-model="item.EPRevenue" />
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="item.id > 0">
                    <b-col>
                        <b-form-group>

                            <template v-slot:label>Gross Profit % </template>
                            <b-row>
                                <b-col>
                                    <b-form-input style="text-align: right;" v-model="item.EPGross"
                                        id="textarea-auto-height" placeholder="" type="number">
                                    </b-form-input>
                                    <!-- <my-currency-input v-model="item.EPGross" /> -->
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row>

            </b-container>
        </b-modal>

        <b-modal v-model="modalRequest" @ok="submitRequest" header-bg-variant="info" header-text-variant="light">
            <template v-slot:modal-title>

                <div>Submit Approval</div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Save</b-button>
                <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Close</b-button>
            </template>
            <b-container>

                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Approver

                            </template>
                            <!-- <b-form-select  v-model="report.employee" class=" pt-0 pb-0" size="md"
                                :options="SuggestEmployees" value-field="id" text-field="name"
                                oninvalid="this.setCustomValidity('Please enter Gender')"
                                oninput="setCustomValidity('')" required>
                            </b-form-select> -->
                            <multiselect v-model="approver" placeholder selectedLabel="are selecting" track-by="hovaten"
                                label="hovaten" select-label="Enter to select" deselectLabel="Enter to remove"
                                :searchable="true" :options="approveList">
                            </multiselect>
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col>
                        <b-form-group>

                            <template v-slot:label>Action </template>
                            <b-row>
                                <b-col>
                                    <b-form-select v-model="item.actionSend" class=" pt-0 pb-0" size="md"
                                        oninvalid="this.setCustomValidity('Please enter Gender')"
                                        oninput="setCustomValidity('')" required>
                                        <b-form-select-option :value="true">Send</b-form-select-option>
                                        <b-form-select-option :value="false">Don't Send</b-form-select-option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                </b-row> -->
            </b-container>
        </b-modal>
        <b-modal v-model="modalLock" @ok="submitLock" header-bg-variant="info" header-text-variant="light">
            <template v-slot:modal-title>

                <div>Lock </div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Lock</b-button>
                <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Close</b-button>
            </template>
            <b-container>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Lock Time
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="item.DatePaid70" :local="local" clearable
                                format="MM-YYYY" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
        <b-modal v-model="modalPayment" @ok="submitPaid" header-bg-variant="info" header-text-variant="light">
            <template v-slot:modal-title>

                <div>Payment</div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Save</b-button>
                <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Close</b-button>
            </template>
            <b-container>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Action
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-select v-model="payment.action" class="mb-3">

                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- Please select an option
                                        --</b-form-select-option>
                                </template>


                                <b-form-select-option value="70">Pay 70%</b-form-select-option>
                                <b-form-select-option value="100">Pay 100%</b-form-select-option>
                                <b-form-select-option value="70All">Pay All 70%</b-form-select-option>
                                <b-form-select-option value="100All">Pay All 100%</b-form-select-option>
                                <b-form-select-option value="U70">Undo payment 70% -> Lock</b-form-select-option>
                                <b-form-select-option value="U100All">Undo payment 100% -> 70%</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="!payment.action.includes('All')">
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Payment month (70%)
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="payment.dateLock" :local="local"
                                clearable format="MM-YYYY" />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row v-if="payment.action.includes('100')">
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Payment completion month (100%)
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="payment.datePaid" :local="local"
                                clearable format="MM-YYYY" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
        <b-modal v-model="modalReport" @ok="exportReport" header-bg-variant="info" header-text-variant="light">
            <template v-slot:modal-title>

                <div>Report</div>
            </template>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Save</b-button>
                <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Close</b-button>
            </template>
            <b-container>
                <b-row>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                Report
                                <span class="text-danger">*</span>
                            </template>
                            <b-form-select v-model="report.type" class="mb-3">

                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- Please select an option
                                        --</b-form-select-option>
                                </template>

                                <b-form-select-option value="All">All</b-form-select-option>
                                <b-form-select-option value="70">70%</b-form-select-option>
                                <b-form-select-option value="100">100%</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="report.type != 'All'">
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                From
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="report.dateFrom" :local="local" clearable
                                format="MM-YYYY" />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group>
                            <template v-slot:label>
                                To
                                <span class="text-danger">*</span>
                            </template>
                            <vue-datepicker-local style="width: 100%" v-model="report.dateTo" :local="local" clearable
                                format="MM-YYYY" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";

import MyCurrencyInput from "../../components/App/MyCurrencyInput.vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "vue-swatches/dist/vue-swatches.css";
import VueDatepickerLocal from "vue-datepicker-local";
export default {
    name: "Meetings",
    components: {

        Multiselect,
        MyCurrencyInput,
        VueDatepickerLocal
    },
    data() {
        return {
            //fields: [],
            fields: [
                {
                    key: "code",
                    label: "Code",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { textAlign: "center", width: "80px !important", },
                },
                {
                    key: "productionHouse",
                    label: "PH",
                    sortable: true,
                    thClass: "align-middle",
                    thStyle: { textAlign: "center" },
                },
                {
                    key: "projectName",
                    label: "Project name",
                    sortable: true,
                    thClass: "align-middle",
                    thStyle: { textAlign: "center" },
                },
                // {
                //     key: "client",
                //     label: "Client",
                //     sortable: true,
                //     thClass: "align-middle",
                //     thStyle: { textAlign: "center" },
                // },
                {
                    key: "ep",
                    label: "EP",
                    sortable: true,
                    thClass: "align-middle",
                    thStyle: { textAlign: "center" },
                },
                {
                    key: "lastDay",
                    label: "Last day of shooting",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { width: "125px", textAlign: "center" },
                },
                {
                    key: "dayOfMasterDelivery",
                    label: "Master Delivery",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { width: "125px !important", textAlign: "center" },
                },

                {
                    key: "dateLiquidation",
                    label: "Day of Liquidation",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { width: "125px !important", textAlign: "center" },
                },


                {
                    key: "epRevenue",
                    label: "Revenue ex VAT",
                    sortable: true,
                    tdClass: "text-right",
                    thClass: "align-middle",
                    thStyle: { textAlign: "center", width: "140px !important" },
                },
                {
                    key: "epGross",
                    label: "Gross Profit %",
                    sortable: true,
                    tdClass: "text-right",
                    thClass: "align-middle",
                    thStyle: { textAlign: "center" },
                },

                {
                    key: "epBonus",
                    label: "Sales Bonus",
                    sortable: true,
                    tdClass: "text-right",
                    thClass: "align-middle",
                    thStyle: { textAlign: "center" },

                },
                {
                    key: "epPaid",
                    label: "Paid (70%)",
                    sortable: true,
                    tdClass: "text-right",
                    thClass: "align-middle",
                    thStyle: { textAlign: "center" },

                },
                {
                    key: "datePaid70",
                    label: "Paid Date (70%)",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { textAlign: "center" },
                },
                {
                    key: "epkpi",
                    label: "KPIs (30%)",
                    sortable: true,
                    tdClass: "text-right",
                    thClass: "align-middle",
                    thStyle: { textAlign: "center" },
                },
                {
                    key: "datePaid100",
                    label: "Paid Date (30%)",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { textAlign: "center" },
                },
                {
                    key: "epApprover",
                    label: "Approved by",
                    sortable: true,
                    thClass: "align-middle",
                    thStyle: { textAlign: "center" },
                },
                {
                    key: "epStatus",
                    label: "Status",
                    sortable: true,
                    thClass: "align-middle",
                    tdClass: "text-center",
                    thStyle: { textAlign: "center" },
                },


                // {
                //     key: "print",
                //     label: "Print",
                //     sortable: true,
                // },
                {
                    key: "action",
                    label: "",
                    thStyle: { width: "50px !important" },
                },
            ],

            local: {
                monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
                    "_"
                ), // months of head
                months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split(
                    "_"
                ), // months of panel
                weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks,
                cancelTip: 'X',
                submitTip: 'Ok'
            },
            items: [],
            itemsOriginal: [],
            optionsCompany: [],
            optionEP: [],
            optionPM: [],
            filterMonth: null,
            search: null,
            item_null: {
                id: 0,
                code: "",
                productionHouse: "",
                projectName: "",
                client: "",
                EP: null,
                dateLiquidation: null,
                EPRevenue: 0,
                EPGross: 0,
                EPBonus: 0,
                EPPaid: 0,
                EPKPI: 0,
                EPStatus: 0,
                EPLock: false,
                PM: null,
                EPApprover: 0,
            },
            item: {
                id: 0,
                code: "",
                productionHouse: "",
                projectName: "",
                client: "",
                EP: null,
                dateLiquidation: null,
                EPRevenue: 0,
                EPGross: 0,
                EPBonus: 0,
                EPPaid: 0,
                EPKPI: 0,
                EPStatus: 0,
                EPLock: false,
                PM: null,
                EPApprover: 0,
                typeLock: "",
                actionSend: true,
                DatePaid70: "",
                DatePaid100: "",
            },
            optionsKyBaoCao_Report3: [
                { value: 0, text: "Jan" },
                { value: 1, text: "Feb" },
                { value: 2, text: "Mar" },
                { value: 3, text: "Apr" },
                { value: 4, text: "May" },
                { value: 5, text: "Jun" },
                { value: 6, text: "Jul" },
                { value: 7, text: "Aug" },
                { value: 8, text: "Sep" },
                { value: 9, text: "Oct" },
                { value: 10, text: "Nov" },
                { value: 11, text: "Dec" },
                { value: 12, text: "Q1" },
                { value: 13, text: "Q2" },
                { value: 14, text: "Q3" },
                { value: 15, text: "Q4" },
                { value: 16, text: "Year" },
            ],
            typePage: null,
            modalShow: false,
            totalRows: 1,
            currentPage: 1,
            perPage: 50,
            SuggestEmployees: [],
            optioncustomer: [],
            approveList: [],
            approver: null,
            itemIdex: 0,
            modalRequest: false,
            modalLock: false,
            modalPayment: false,
            payment: {
                dateLock: null,
                datePaid: null,
                action: "70"
            },
            searchBonus: {
                status: null,
                productionHouse: null,
                approveBy: null,
                optionApprove: [],
                filterDate: null,
                from: null,
                to: null,
                typeDate: "Liquidation",
            },
            report: {
                type: "70",
                dateTo: null,
                dateFrom: null,
            },
            modalReport: false,
            newPM: [],
        };
    },
    computed: {
        bonus_sf_view_all() {
            return this.$store.getters.hasPermission("bonus_sf_view_all");
        },
        bonus_sf_add() {
            return this.$store.getters.hasPermission("bonus_sf_add");
        },
        bonus_sf_edit() {
            return this.$store.getters.hasPermission("bonus_sf_edit");
        },
        bonus_sf_delete() {
            return this.$store.getters.hasPermission("bonus_sf_delete");
        },
        bonus_sf_approve() {
            return this.$store.getters.hasPermission("bonus_sf_approve");
        },
        bonus_sf_lock() {
            return this.$store.getters.hasPermission("bonus_sf_lock");
        },
        bonus_sf_paid() {
            return this.$store.getters.hasPermission("bonus_sf_paid");
        },
        bonus_sf_report() {
            return this.$store.getters.hasPermission("bonus_sf_report");
        },
    },
    beforeRouteEnter(to, from, next) {
        //this.typePage = to.params.type;
        axios
            .all([
                axios.get(`/api/SalesBonus/getAll`),
                axios.get("/api/SalesBonus/GetDepartment"),
                axios.get("/api/SalesBonus/SuggestEmployee"),
                axios.get("/api/SalesBonus/customer"),
                axios.get("/api/role/2058/employee"),
                axios.get("/api/SalesBonus/getPMSuggest"),
                //axios.get("/api/picklist?q=vitricongviec"),
            ])
            .then(
                axios.spread((bonusRate, department, employees, customers, approveList, newPM) => {
                    next((vm) =>
                        vm.initData(bonusRate.data, department.data, employees.data, customers.data, approveList.data, newPM.data)
                    );
                })
            );
    },
    beforeRouteUpdate(to, from, next) {
        axios
            .get("/api/SalesBonus/getAll", { params: to.query })
            .then((response) => {
                this.items = response.data;
                this.onFiltered(response.data);
            })
            .catch((err) => {
                next();
            });
    },
    methods: {
        initData(bonusRate, department, employees, customers, approveList, newPM) {
            //this.$log("Runnnnnnnnnnnnnnnnn");
            this.approveList = approveList.items;
            this.optioncustomer = customers;
            this.SuggestEmployees = employees;
            this.items = bonusRate;
            this.optionsCompany = department;
            this.onFiltered(bonusRate);
            this.optionPM = newPM;
            this.optionEP = this.SuggestEmployees.filter(e => e.position == 'EP' || e.position == 'Director' || e.position == 'Chairman');
            approveList.items.forEach(element => {
                //var emp = employees.filter(x => x.id == element.id);
                var item = { value: element.id, text: element.hovaten };
                this.searchBonus.optionApprove.push(item);
            });
        },
        changeDateFilter() {
            const monthDays = {
                0: [0, 1, 0, 31],
                1: [1, 1, 2, 0],
                2: [2, 1, 2, 31],
                3: [3, 1, 3, 30],
                4: [4, 1, 4, 31],
                5: [5, 1, 5, 30],
                6: [6, 1, 6, 31],
                7: [7, 1, 7, 31],
                8: [8, 1, 8, 30],
                9: [9, 1, 9, 31],
                10: [10, 1, 10, 30],
                11: [11, 1, 11, 31],
                12: [0, 1, 2, 31],
                13: [3, 1, 5, 30],
                14: [6, 1, 8, 30],
                15: [9, 1, 11, 31],
                16: [0, 1, 11, 31]
            };
            if (this.searchBonus.filterDate != null) {
                const [fromMonth, fromDay, toMonth, toDay] = monthDays[this.searchBonus.filterDate];
                this.searchBonus.from = new Date(new Date().getFullYear(), fromMonth, fromDay);
                this.searchBonus.to = new Date(new Date().getFullYear(), toMonth, toDay);
            } else {
                this.searchBonus.from = null;
                this.searchBonus.to = null;
            }
            this.queryItem();
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        SendRequest(data) {
            this.itemIdex = data.index;
            this.item.id = data.item.id;
            this.approver = null;
            this.item.actionSend = true;
            if (data.item.epApprover != null) {
                this.approveList.forEach(element => {
                    if (element.id == data.item.epApprover) {
                        this.approver == element;
                    }
                });
            }
            this.modalRequest = true;

        },
        PrintDetail() {

            const model = {
                projectID: this.item.id,
                type: "Sale",
            };
            axios.get(`/api/SalesBonus/PrintDetail`, {
                responseType: 'blob',
                params: model
            })
                .then((res) => {
                    let filename = res.headers["content-disposition"]
                        .split(";")
                        .find(function (el) {
                            if (el.includes("filename=")) return el;
                        })
                        .replace("filename=", "")
                        .trim();
                    const url = window.URL.createObjectURL(
                        new Blob([res.data], {
                            type: "application/vnd.ms-excel;charset=utf-8",
                        })
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename); // or any other extension
                    document.body.appendChild(link);
                    link.click();
                    this.Reporting = false;
                })
                .catch((err) => {
                    this.Reporting = false;
                    const blob = err.response.data;
                    const reader = new FileReader();
                    reader.onload = () => {
                        let errorText = reader.result;

                        // Ensure the message is a string
                        if (typeof errorText !== 'string') {
                            errorText = JSON.stringify(errorText);
                        }

                        // Assuming errorText is JSON formatted
                        try {
                            const errorJson = JSON.parse(errorText);
                            this.$toast.error(errorJson.message || errorText, "Error", { timeout: 3000 });

                        } catch (e) {
                            this.$toast.error(errorText, "Error", { timeout: 3000 });
                        }
                    };
                    reader.onerror = () => {
                        this.$toast.error("An error occurred while processing the error response.", "Error", { timeout: 3000 });
                    };
                    reader.readAsText(blob);

                });
        },
        submitRequest() {
            if (this.approver == [] || this.approver == null) {
                this.$toast.error("Approver is empty !", "ERROR", {
                    timeout: 3000,
                });
                return;
            }
            this.item.actionSend = true;
            //this.$log(this.approver);
            axios
                .get(`/api/SalesBonus/SentMail?projectID=${this.item.id}&updatedBy=${this.$store.state.auth.accountId}&approverID=${this.approver.id}&sent=${this.item.actionSend}`)
                .then((res) => {
                    this.items.splice(this.itemIdex, 1, res.data[0]);
                    //item.status = 'PM-Pending Approval';
                    this.$toast.success("Sent Mail successfully !", "Successful", {
                        timeout: 3000,
                    });
                })
                .catch((err) => {
                    this.$toast.error(err.response.data, "ERROR", {
                        timeout: 3000,
                    });
                });
        },
        openModalReport() {
            this.modalReport = true;
        },
        exportReport() {
            const formSubmit = {
                type: this.report.type,
                to: this.report.dateTo,
                from: this.report.dateFrom,
            };
            axios.get(`/api/SalesBonus/Report`, {
                responseType: 'blob',
                params: formSubmit
            })
                .then((res) => {
                    let filename = res.headers["content-disposition"]
                        .split(";")
                        .find(function (el) {
                            if (el.includes("filename=")) return el;
                        })
                        .replace("filename=", "")
                        .trim();
                    const url = window.URL.createObjectURL(
                        new Blob([res.data], {
                            type: "application/vnd.ms-excel;charset=utf-8",
                        })
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", filename); // or any other extension
                    document.body.appendChild(link);
                    link.click();

                })
                .catch((err) => {

                    const blob = err.response.data;
                    const reader = new FileReader();
                    reader.onload = () => {
                        let errorText = reader.result;

                        // Ensure the message is a string
                        if (typeof errorText !== 'string') {
                            errorText = JSON.stringify(errorText);
                        }

                        // Assuming errorText is JSON formatted
                        try {
                            const errorJson = JSON.parse(errorText);
                            this.$toast.error(errorJson.message || errorText, "Error", { timeout: 3000 });

                        } catch (e) {
                            this.$toast.error(errorText, "Error", { timeout: 3000 });
                        }
                    };
                    reader.onerror = () => {
                        this.$toast.error("An error occurred while processing the error response.", "Error", { timeout: 3000 });
                    };
                    reader.readAsText(blob);

                });
        },
        openModal() {

            this.item = JSON.parse(JSON.stringify(this.item_null));
            this.modalShow = true;
            // this.optionPM = [];
            // this.optionEP = [];
        },
        openModalPayment() {

            this.modalPayment = true;
        },
        convertName(id) {
            var rs = "";
            this.SuggestEmployees.forEach(element => {
                //this.$log(element.id + " - " + id);
                if (element.id == id) {
                    //this.$log(element.name);
                    rs = element.name;
                }
            });
            return rs;
        },

        submitPaid() {
            if (!this.payment.action.includes('All')) {
                if (this.payment.dateLock == null || this.payment.dateLock == '') {
                    this.$toast.error("Payment month is empty !", "ERROR", {
                        timeout: 3000,
                    });
                    return;
                }
            }
            if (this.payment.action.includes('100')) {
                if ((this.payment.datePaid == null || this.payment.datePaid == '')) {
                    this.$toast.error("Payment completion month is empty !", "ERROR", {
                        timeout: 3000,
                    });
                    return;
                }
            }

            const formSubmit = {
                LockDate: this.payment.dateLock,
                action: this.payment.action,
                PaidDate: this.payment.datePaid
            };
            axios
                .post(`/api/SalesBonus/PaidRequest`, formSubmit)
                .then((res) => {
                    this.queryItem();
                    this.$toast.success("Action successfully !", "Successful", {
                        timeout: 3000,
                    });
                })
                .catch((err) => {
                    this.$toast.error(err.response.data, "ERROR", {
                        timeout: 3000,
                    });
                });


        },
        submitLock() {
            if (this.item.DatePaid70 == null || this.item.DatePaid70 == '') {
                this.$toast.error("Date is empty !", "ERROR", {
                    timeout: 3000,
                });
                return;
            } else {
                const formSubmit = {
                    projectID: this.item.id,
                    DatePaid70: this.item.DatePaid70,
                };
                axios
                    .post(`/api/SalesBonus/LockRequest`, formSubmit)
                    .then((res) => {
                        this.items.splice(this.itemIdex, 1, res.data[0]);
                        this.$toast.success("Lock successfully !", "Successful", {
                            timeout: 3000,
                        });
                    })
                    .catch((err) => {
                        this.$toast.error(err.response.data, "ERROR", {
                            timeout: 3000,
                        });
                    });
            }

        },
        lockProject(data) {
            if (data.item.epLock != true) {
                this.item.id = data.item.id;
                this.item.DatePaid70 = "";
                this.itemIdex = data.index;
                this.modalLock = true;
            } else {
                this.$toast.question("Do you agree to Unlock this project?", "Warning", {
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    displayMode: "once",
                    position: "center",
                    buttons: [

                        [
                            "<button><b>UnLock</b></button>",
                            (instance, toast) => {
                                const formSubmit = {
                                    projectID: data.item.id,
                                    DatePaid70: null,

                                };
                                axios
                                    .post(`/api/SalesBonus/LockRequest`, formSubmit)
                                    .then((res) => {
                                        this.items.splice(data.index, 1, res.data[0]);
                                        this.$toast.success("Unlock successfully !", "Successful", {
                                            timeout: 3000,
                                        });
                                    })
                                    .catch((err) => {
                                        this.$toast.error(err.response.data, "ERROR", {
                                            timeout: 3000,
                                        });
                                    });
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                            true,
                        ],
                        [
                            "<button>Cancel</button>",
                            function (instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                        ],
                    ],
                });
            }
        },
        approveRequest(data) {


            if (data.item.epStatus == 'EP-Approved') {
                this.$toast.question("Do you agree to reject this project?", "Warning", {
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    displayMode: "once",
                    position: "center",
                    buttons: [

                        [
                            "<button><b>Reject</b></button>",
                            (instance, toast) => {
                                axios
                                    .get(`/api/SalesBonus/UnApproveRequest?projectID=${data.item.id}`)
                                    .then((res) => {
                                        this.items.splice(data.index, 1, res.data[0]);
                                        this.$toast.success("Reject successfully !", "Successful", {
                                            timeout: 3000,
                                        });
                                    })
                                    .catch((err) => {
                                        this.$toast.error(err.response.data, "ERROR", {
                                            timeout: 3000,
                                        });
                                    });
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                            true,
                        ],
                        [
                            "<button>Cancel</button>",
                            function (instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                        ],
                    ],
                });
            } else {
                this.$toast.question("Do you agree to approve this project?", "Warning", {
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    displayMode: "once",
                    position: "center",
                    buttons: [
                        [
                            `<button><b>Approve</b></button>`,
                            (instance, toast) => {
                                axios
                                    .get(`/api/SalesBonus/ApproveRequest?projectID=${data.item.id}`)
                                    .then((res) => {
                                        this.items.splice(data.index, 1, res.data[0]);
                                        this.$toast.success("Approve successfully !", "Successful", {
                                            timeout: 3000,
                                        });
                                    })
                                    .catch((err) => {
                                        this.$toast.error(err.response.data, "ERROR", {
                                            timeout: 3000,
                                        });
                                    });
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                            true,
                        ],
                        [
                            "<button><b>Reject</b></button>",
                            (instance, toast) => {
                                axios
                                    .get(`/api/SalesBonus/UnApproveRequest?projectID=${data.item.id}`)
                                    .then((res) => {
                                        this.items.splice(data.index, 1, res.data[0]);
                                        this.$toast.success("Reject successfully !", "Successful", {
                                            timeout: 3000,
                                        });
                                    })
                                    .catch((err) => {
                                        this.$toast.error(err.response.data, "ERROR", {
                                            timeout: 3000,
                                        });
                                    });
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                            true,
                        ],
                        [
                            "<button>Cancel</button>",
                            function (instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                            },
                        ],
                    ],
                });
            }

        },
        openUpdateModal(data) {

            //this.item = JSON.parse(JSON.stringify(data.item));
            //this.$log(data);
            this.item.id = data.item.id;
            this.item.code = data.item.code;
            this.item.productionHouse = data.item.productionHouse;
            this.item.client = this.optioncustomer.find(e => e.ten == data.item.client);
            this.item.projectName = data.item.projectName;

            this.item.EP = this.SuggestEmployees.find(e => e.id == data.item.ep);
            this.item.PM = this.optionPM.find(e => e.id == data.item.pm);
            this.item.dateLiquidation = data.item.dateLiquidation;
            this.item.EPRevenue = data.item.epRevenue;
            this.item.EPGross = data.item.epGross;

            //this.$log(this.item);
            this.itemIdex = this.items.indexOf(data.item);
            this.modalShow = true;
        },

        convertDate(value) {
            return this.$convert_date_string(value);
        },
        changeDate() {
            if (this.searchBonus.from != null && this.searchBonus.to != null) {
                this.queryItem();
            }
        },
        unlockHopitalCity(city) {
            this.item.EP = null;
        },
        lockHopitalCity() {
            this.item.EP = null;
        },
        convertToMMYYYY2(dateString) {

            if (dateString == null) return dateString;
            dateString = this.$convert_date_string(dateString);
            // Split the input string into day, month, and year components
            const [day, month, year] = dateString.split('/');

            // Create a new Date object using the components
            const dateObject = new Date(`${month}/01/${year}`);

            // Get month and year components from the Date object
            const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const convertedYear = dateObject.getFullYear();

            // Return the formatted string
            return `${convertedMonth}-${convertedYear}`;
        },

        convertToMMYYYY(dateString) {
            if (dateString == null) return dateString;
            // Split the input string into day, month, and year components
            const [day, month, year] = dateString.split('/');

            // Create a new Date object using the components
            const dateObject = new Date(`${month}/01/${year}`);

            // Get month and year components from the Date object
            const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const convertedYear = dateObject.getFullYear();

            // Return the formatted string
            return `${convertedMonth}-${convertedYear}`;
        },
        storeItem(bvModalEvt) {

            // this.item.updateBy = this.$store.state.auth.accountId;
            // this.item.type = this.typePage;
            // if(this.item.productionHouse == null || this.item.productionHouse == ""){
            //     this.$toast.error("Production House Name is empty", "Error", {
            //         timeout: 3000,
            //     });
            //     return;
            // }
            if (this.item.dateLiquidation == "") {
                this.item.dateLiquidation = null;
            }
            // var ep = null;
            // if(this.item.EP != null){
            //     ep = this.item.EP.id;
            // }
            // var pm = null;
            // if(this.item.PM != null){
            //     pm = this.item.PM.id;
            // }


            if (this.item.EP == null) {
                this.$toast.error("EP Name is empty", "Error", {
                    timeout: 3000,
                });
                return;
            }

            if (this.item.PM == null) {
                this.$toast.error("PM Name is empty", "Error", {
                    timeout: 3000,
                });
                return;
            }
            if (this.item.EPGross != null && this.item.EPGross != '') this.item.EPGross = Number(this.item.EPGross);
            else this.item.EPGross = null;
            const formSubmit = {
                id: this.item.id,
                code: this.item.code,
                productionHouse: this.item.productionHouse,
                client: this.item.client.ten,
                projectName: this.item.projectName,
                ep: this.item.EP.id,
                pm: this.item.PM.id,
                dateLiquidation: this.item.dateLiquidation,
                epRevenue: this.item.EPRevenue,
                epGross: this.item.EPGross,
                updatedBy: this.$store.state.auth.accountId
            };


            axios
                .post(`/api/SalesBonus/storeSalesBonus`, formSubmit)
                .then((res) => {
                    if (this.item.id <= 0) {
                        this.items.push(res.data[0]);
                        this.$toast.success("Create successfully !", "Successful", {
                            timeout: 3000,
                        });
                    } else {
                        //this.$log(this.itemIdex);
                        this.items.splice(this.itemIdex, 1, res.data[0]);
                        this.$toast.success("Update successfully !", "Successful", {
                            timeout: 3000,
                        });
                        //this.$log(res.data[0]);
                    }
                    this.modalShow = false;



                })
                .catch((err) => {
                    this.$toast.error(err.response.data, "Error", { timeout: 3000 });
                });



        },
        // updateProduction() {
        //     //this.$log("updateProduction");
        //     this.item.EP = null;
        //     this.item.PM = null;
        //     if (this.item.productionHouse.length > 0) {
        //         this.optionPM = this.SuggestEmployees.filter(e => e.position == 'PM' && e.company == this.item.productionHouse);
        //         this.optionEP = this.SuggestEmployees.filter(e => e.position == 'EP' && e.company == this.item.productionHouse);


        //     }
        // },
        queryItem() {
            let query = Object.assign({}, this.$route.query);
            this.currentPage = 1;
            query.search = this.search;
            query.status = this.searchBonus.status;
            query.productionHouse = this.searchBonus.productionHouse;
            query.approveBy = this.searchBonus.approveBy;
            query.typeDate = this.searchBonus.typeDate;
            query.to = this.convert_date_string(this.searchBonus.to);
            query.from = this.convert_date_string(this.searchBonus.from);
            //this.item = null;
            this.$router.push({ query: query });
        },
        convert_date_string(date) {
            if (date == null) return null;
            if (date == '') return null;
            return this.$moment(date)
                .format("YYYY/MM/DD")
                .toString();
        },
        deleteItem(data) {
            this.$toast.question("Do you really want to delete?", "Warning", {
                timeout: 20000,
                close: false,
                overlay: true,
                displayMode: "once",
                position: "center",
                buttons: [
                    [
                        "<button><b>Yes</b></button>",
                        (instance, toast) => {
                            axios
                                .delete(`/api/SalesBonus/delete?id=${data.item.id}&deleteBy=${this.$store.state.auth.accountId}`)
                                .then((res) => {
                                    this.items.splice(data.index, 1);
                                    this.$toast.success("Deleted successfully !", "Successful", {
                                        timeout: 3000,
                                    });
                                })
                                .catch((err) => {
                                    this.$toast.error(err.response.data, "ERROR", {
                                        timeout: 3000,
                                    });
                                });
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                        true,
                    ],
                    [
                        "<button>No</button>",
                        function (instance, toast) {
                            instance.hide({ transitionOut: "fadeOut" }, toast, "button");
                        },
                    ],
                ],
            });
        },
    },
};
</script>
